export default <T>(collection: Array<T>): Array<T> => {
  return [... new Set(collection)];
}
